<template>
    <!-- top -->
    <ul class="topicpath mb16">
        <li>
            <router-link :to="generateLinkParams(1,'top')" @click.native="reload">{{$t(topPageNm)}}</router-link>
        </li>
        <template v-if="getLengthObj(navList) > 0">
            <li v-for="(item, index) in navList" :key="index">
                <template v-if="category_cd == item.CATEGORY_CD">
                    {{item.CATEGORY_NM}}
                </template>
                <router-link v-else
                    :to="{ path: '/' + site + '/c/' + item.CATEGORY_CD}"
                    :key="index" @click.native="reload">
                    {{item.CATEGORY_NM}}
                </router-link>
            </li>
            <li>{{ itemNm }}</li>
        </template>
        <template v-else-if="getLengthObj(navListCustom) > 0">
            <li v-for="(item, index) in navListCustom" :key="index">
                <template v-if="(item.CATEGORY_CD && category_cd == item.CATEGORY_CD) || !item.routerName || !item.param">
                    {{item.title}}
                </template>
                <router-link v-else
                    :to="generateLinkParams(item.param.pageNo,item.routerName)"
                    :key="index" @click.native="reload">
                    {{item.title}}
                </router-link>
            </li>
        </template>
        <li v-else>
            {{decriptPage}}
        </li>
        
    </ul>
</template>

<script>
import SiteConstants from 'assets/const/SiteConstants.json';
import common from "assets/js/common";
export default {
    name: "Breadcrumb",
    props:{
        navList:{
            type: Array,
        },
        routerNmItem: {
            type: String,
            default: ""
        },
        routerNmItemPageNo: {
            type: String,
            default: ""
        },
        decriptPage: {
            type: String,
            default: ""
        },
        navListCustom:{
            type: Array
        },
        topPageNm:{
            type: String,
            default: 'common.labels.homePage'
        },
        itemNm:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            SiteConstants: SiteConstants,
            site: "",
            category_cd: ""
        }
    },
    mounted: function(){
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.category_cd = _this.$router.history.current.fullPath.split("/")[3];
    },
    methods: {
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        reload: function() {
            window.location.reload();
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        }
    },
}
</script>
